<template>
  <div>
    <EmptyView v-if="isShowEmptyView" tabMyList=tabMyList style="margin-top: 150px;" v-on:reload-event="getMyListVacation(true)"/>
    <v-card id="cardTabMyList" outlined>
        <div v-if="isShowErrorView" v-on:click="getMyListVacation(true)" class="mx-auto" style="margin-top:100px; width:350px; height:400px;" >
          <ErrorView class="mx-auto" />
        </div>
        <div v-for="(vacationIds, date) in dividerDateTitles" :key="date">
        <DividerLine :groupTile="date" />
        <VacationItemRow v-for="vacationId in vacationIds" :key="vacationId" :vacationDate="date" :vacationInfo="getVacationById(vacationId)"/>
      </div>
      <div v-if="filter.showDateChoose && isShowAllList"
        class="" style="text-align: center; align-items: center; color: #1f97fe; font-size: 0.875rem; padding: 30px 0; cursor:pointer;">
       <button v-on:click="handleClick()">
         <span style="padding-right: 5px; ">{{ $t("show_all_month") }}</span>
         <img  src="@/assets/alllistarrow.png" alt="required" width="6" />
       </button>
      </div>
    </v-card>
  </div>
</template>

<script>
import Vue from 'vue';
import VacationItemRow from "@/components/commonui/topView/VacationItemRow";
import EmptyView from "../commonui/topView/EmptyView";
import ErrorView from "../commonui/topView/ErrorView";
import DividerLine from "../commonui/topView/DividerLine";
import { ListEvents, DefaultValues, TabNames, groupedDatesbyId, VacationStatus } from "@/utilities/CommonUtilities";
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import { resizeMixin } from '../../utilities/CommonUtilities';

export default {
  mixins: [resizeMixin],
  components: {VacationItemRow, EmptyView, ErrorView, DividerLine},
  data() {
    return {
      pageSize: DefaultValues.page_size,
      currentPageNumber: 1,
      pageInfo: {},
      listVacations:[],
      isShowEmptyView: false,
      isShowErrorView: false,
      isLoading: false,
      isDestroyed: false,
      keyIndex: 0,
      dividerDateTitles: [],
      tabMyList: true,
      isShowAllList: false
    }
  },
  computed: {
    ...mapState(["userInfo", "token", "listUser"]),
    ...mapState({
      tabSelecting: state => state.homeData.currentTab,
      selectedTab: (state) => state.homeData.selectedTab,
    }),
    ...mapGetters({
      getTabInfo: "homeData/getTabInfo",
      filter: "homeData/getFilterInfo",
    })
  },
  methods: {
    ...mapMutations({
        saveTabInfo: "homeData/setTabInfo",
        saveFilter: "homeData/saveFilter",
    }),
    ...mapActions({
        resetAllTabInfo: "homeData/resetAllTabInfo"
    }),
    getVacationById(id) {
      return this.listVacations.find(vacation => vacation.id === id);
    },
    //Change date conditions.
    updateDividerDateTitles() {
      if (this.filter.firstDayOfMonth && this.filter.lastDayOfMonth) {
        let startDate = new Date(this.filter.firstDayOfMonth);
        let endDate = new Date(this.filter.lastDayOfMonth);
        if(this.filter.showDateChoose){
          startDate = new Date(this.filter.dateChoosed);
          endDate = new Date(this.filter.dateChoosed);
        }
        this.dividerDateTitles = groupedDatesbyId(this.listVacations, startDate, endDate, this.listUser);
        if (Object.keys(this.dividerDateTitles).length === 0) {
        this.isShowEmptyView = true;
        } else {
        this.isShowEmptyView = false;
        }
      }
    },
    handleClick() {
    this.$nextTick(() => {
      var filterInfoTemp = {};
        filterInfoTemp.showDateChoose = false;
          filterInfoTemp.searchName = "";
          let yearMonth = this.filter.dateChoosed.substring(0, 7)
          filterInfoTemp.dateChoosed = yearMonth;
          if(this.filter.color != undefined) filterInfoTemp.color = this.filter.color;
          filterInfoTemp.toDate = this.filter.lastDayOfMonth;
          filterInfoTemp.firstDayOfMonth = this.filter.firstDayOfMonth;
          filterInfoTemp.lastDayOfMonth = this.filter.lastDayOfMonth;
          this.saveFilter(filterInfoTemp);
          this.updateDividerDateTitles();
    });
  },
    refreshDataFromDatePicker() {
      if (this.tabSelecting === TabNames.MyList && this.selectedTab === TabNames.All) this.getMyListVacation(true);
    },
    async getMyListVacation(isShowIndicator) {
      if(this.isLoading || this.listUser == null || this.listUser.length == 0) {
        return;
      }
      this.isLoading = true;
      if(isShowIndicator) this.notifyBus.$emit(ListEvents.showLoadingIndicator);
      try{
        let params = {
          'token': this.token, 
          'limit': DefaultValues.page_size,
          'offset': (this.currentPageNumber - 1) * DefaultValues.page_size,
          'order_from':'asc'
        };

        if (this.filter != null) {
          params["from_date"] = `${this.filter.firstDayOfMonth} 00:00:00`;
          params["to_date"] = `${this.filter.lastDayOfMonth} 23:59:59`;
          params["order_from"] = "desc";
        }
        
        let response = await this.dataSource.getData(this.dataSource.listVacations, params);
        let vacationsInPage = response.data['vacations'];
        let totalPage = response.data['totalPage'];

        this.pageInfo.pageItems = vacationsInPage;
        this.pageInfo.totalPage = totalPage;
        this.pageInfo.currentPage = this.currentPageNumber;
        this.isShowAllList  = true;
        
        this.listVacations = vacationsInPage.filter(vacation => 
          vacation.user_id === this.userInfo.userID &&
          (vacation.status === VacationStatus.Approved || vacation.status === VacationStatus.Rejected)
        );
        this.listCalendars = vacationsInPage.filter(vacation => 
          vacation.user_id === this.userInfo.userID 
        );
        this.keyIndex += 1; 
        if(this.listVacations.length == 0) {
          this.isShowEmptyView = true;
        } else {
          this.isShowEmptyView = false;
        }
        let thisInfo = {};
        Object.assign(thisInfo, this.pageInfo);
        this.saveTabInfo({ tabInfo: thisInfo, tabName: TabNames.MyList});

        if(this.isDestroyed) return;
        this.notifyBus.$emit(ListEvents.setStatusMonth, this.listCalendars)
        
        this.notifyBus.$emit(ListEvents.setPagination, { currentPageNumber: this.currentPageNumber, totalPage: totalPage});

        //hide error view
        this.isShowErrorView = false;
      } catch(ex) {
        //error at the first time
        if(this.pageInfo.totalPage == null) {
          this.isShowErrorView = true;
          return;
        }

        this.currentPageNumber = this.pageInfo.currentPage;
        this.notifyBus.$emit(ListEvents.setPagination, { currentPageNumber: this.pageInfo.currentPage, totalPage: this.pageInfo.totalPage});
        if(isShowIndicator) {
           this.notifyBus.$emit(ListEvents.showOKDialog, this.$i18n.t('common_unknown_error'));
        }
        return;
      } finally {
        if(isShowIndicator) this.notifyBus.$emit(ListEvents.hideLoadingIndicator);
        this.isLoading = false;
      }
    }
  },
  watch: {
    listVacations: {
    handler() {
    this.updateDividerDateTitles();
    },
    deep: true
    }
  },
  mounted() {
    // this.updateDividerDateTitles();
    this.notifyBus.$on(ListEvents.vacationList, this.refreshDataFromDatePicker);
  },
  created() {
    // this.updateDividerDateTitles();
    if (this.homeViewBus instanceof Vue) {
      this.homeViewBus.$on(ListEvents.loadDataCompleted, (tabName) => {
        if(tabName == null) {
          this.getMyListVacation(true);
        }
      });
    }

    this.notifyBus.$on(ListEvents.paginationChanged, (newCurrentPage) => {
      if(this.isLoading || newCurrentPage == this.currentPageNumber || this.isDestroyed) return;

      this.currentPageNumber = newCurrentPage;
      this.getMyListVacation(true);
    });

    this.notifyBus.$on(ListEvents.reloadAllTabs,(reloadAll) => {
      if(this.isDestroyed) return;

      if(reloadAll) {
        this.resetAllTabInfo();

        this.pageInfo = this.getTabInfo(TabNames.MyList);
        this.currentPageNumber = this.pageInfo.currentPage;
        if(this.pageInfo.totalPage != null) {
          this.notifyBus.$emit(ListEvents.setPagination, { currentPageNumber: this.pageInfo.currentPage, totalPage: this.pageInfo.totalPage});
        }
      }
      this.getMyListVacation(true);
    });
    
    this.getMyListVacation(this.pageInfo.totalPage == null);
  },
  beforeDestroy: function() {
    this.isDestroyed = true;
    this.notifyBus.$off(ListEvents.vacationList, this.refreshDataFromDatePicker);
  },
  inject: ["dataSource", "notifyBus", "homeViewBus"],
};
</script>

<style scoped>
#cardTabMyList{
  background-color: #ffffff;
  border-color: #ffffff;
  border-radius:0px;
}
</style>
